/**
 * @author xiaohuangmaoth
 * @description 个人路径完成率
 * @Date 2021/03/02
 */
import React from "react";
import { connect } from "dva";
import { framework_tool, component_tool } from "@/tool";
import { templateConfig, reduxTemplateCofig } from "./config";
import column from './column';
import { mapStateToProps, handleExport } from '../../utils';

const { WizContainer, WizReduxTemplate } = framework_tool;
const { WizModal } = component_tool

class PersonalPathCompletion extends WizContainer {
  componentName = "PersonalPathCompletion";

  constructor(props) {
    super(props)
  }

  handleAccomplishTypeClick = text => {
    WizModal.info({
      icon:null,
      title: '评语',
      content: (
        <div>{ text }</div>
      ),
      okText: '关闭',
    });
  }

  _render() {
    const _reduxTemplateCofig = reduxTemplateCofig({
      templateConfig: templateConfig.call(this),
      apiDataFormat: {
        export: handleExport.bind(this, { title: '个人路径完成率', column })
      },
    });

    return <React.Fragment>
      <WizReduxTemplate {..._reduxTemplateCofig} />
    </React.Fragment>
  }
}

export default connect(mapStateToProps.bind(this, { nameSpace: 'pathReport', method: 'getPageListStudentComplete' }))(PersonalPathCompletion);
